"use client";

import { usePathname } from "next/navigation";
import Header from "./Header";
import { RouteGuard } from "@/components/PermissionGuard";
import { isPublicRoute, getDomainConfig } from "@/lib/domainConfig";

export function LayoutWrapper({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  
  // Get domain config for the current hostname
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const domainConfig = getDomainConfig(hostname);
  
  // Check if current route is public (should not be protected by RouteGuard)
  const isPublic = isPublicRoute(pathname, domainConfig);
  
  // Special case: permission demo page (might be intentionally separate from domain config)
  const isPermissionTest = pathname === "/permission-test";

  // Auth pages and error pages should render without header/navigation
  const isAuthPage = pathname === "/login" || pathname.startsWith("/auth");
  const isErrorPage = pathname.startsWith("/error/");

  if (isAuthPage || isErrorPage) {
    // For auth pages and error pages, render children directly (no header/navigation)
    return <>{children}</>;
  }

  if (isPublic || isPermissionTest) {
    // For public pages, show header but no RouteGuard
    return (
      <Header>{children}</Header>
    );
  }

  return (
    <RouteGuard>
      <Header>{children}</Header>
    </RouteGuard>
  );
}